import { gql } from '@apollo/client';

export default class CommissionsMutate {
    static SAVE_COMMISSIONS = gql`
        mutation saveCommissions($accountNumber: Int!, $commissions: CommissionsInput) {
            saveCommissions(accountNumber: $accountNumber, commissions: $commissions)
        }
    `;
}
